/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_DismissInputs */

const en_capture_dismiss = /** @type {(inputs: Capture_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const he_capture_dismiss = /** @type {(inputs: Capture_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התעלם`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Capture_DismissInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_dismiss = /** @type {((inputs?: Capture_DismissInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_DismissInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_dismiss(inputs)
	return he_capture_dismiss(inputs)
});